import { useCallback, useRef } from "react";
import { css } from "@stubhub/broadway-foundation/css";
import { ChipKind, ToggleChip } from "@stubhub/broadway-web";
import { PE_KEYS } from "src/shared/constants/PageEventKeys";
import { PE_TYPE } from "src/shared/constants/PageEventTypes";
import { useStorePageEvent } from "src/shared/hooks/useStorePageEvent";
import { useHomePageModelData } from "src/website-apps/responsive/stubhub-home/hooks/useHomePageModelData";
import { HorizontalScrollingBlurContainer } from "src/website-apps/shared/components/HorizontalScrollingBlurContainer";
import { Container } from "./PageFiltersOnHome.styled";

const genreFilterContainer = css({
  display: "flex",
  columnGap: "primitives.150",
  paddingInline: "primitives.25",
});

const chipClasses = { root: css({ marginBlock: "primitives.25" }) };

const GenreOption = ({ genreOption, selected, handleChange = () => {} }) => (
  <ToggleChip
    onClick={() => handleChange(genreOption.value)}
    selected={selected}
    label={genreOption.label}
    kind={ChipKind.Brand}
    classes={chipClasses}
  />
);

/**
 * CarouselGenreFilter component displays a horizontal scrolling list of genre filter options
 * and allows selecting a specific genre for the carousels on home page
 * @param {object} props
 * @param {number} props.selectedTlc - The currently selected top level category id
 * @param props.setSelectedTlc
 */
export const CarouselGenreFilter = ({ selectedTlc, setSelectedTlc }) => {
  const storePageEvent = useStorePageEvent();
  const scrollerRef = useRef(null);
  const { genreFilterOptions = [] } = useHomePageModelData();

  const handleChange = useCallback(
    (value) => {
      storePageEvent(PE_TYPE.CLICK, PE_KEYS.HOME_CAROUSEL_FILTER_GENRE_CLICK, `${selectedTlc}_${value}`);
      setSelectedTlc(value);
    },
    [setSelectedTlc, selectedTlc, storePageEvent],
  );

  return (
    <Container>
      <HorizontalScrollingBlurContainer scrollerRef={scrollerRef}>
        <div className={genreFilterContainer}>
          {genreFilterOptions.map((filterOption) => (
            <GenreOption
              key={filterOption.value}
              genreOption={filterOption}
              selected={selectedTlc === filterOption.value}
              handleChange={handleChange}
            />
          ))}
        </div>
      </HorizontalScrollingBlurContainer>
    </Container>
  );
};
